import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import UserSelectModal from "../common/UserSelectModal";
import PartnerSelectModal from "../common/PartnerSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

function ProcessUpdateModal({ title, onClose, handleView, userTypeModalOption, externalModalOption, originRows, MenuUpdateYN, MenuDeleteYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    process_id: 0,
    process_name: '',
    process_external_yn: '',
    process_external_partner_id: '',
    process_external_partner_name: '',
    process_desc: ''
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectModalOpen, setSelectModalOpen] = useState(false);
  const [selectUserData, setSelectUserData] = useState('');
  const [selectPartnerModalTitle, setSelectPartnerModalTitle] = useState('');
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.process_user_id, row.process_reg_user_id, row.process_update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  const handleInitSelect = () => {
    // 공정 정보
    setUpdateUserRows([]);
    
    setInputs({
      process_id: originRows[0].process_id,
      process_name: originRows[0].process_name,
      process_external_yn: originRows[0].process_external_yn,
      process_external_partner_id: originRows[0].process_external_partner_id,
      process_external_partner_name: originRows[0].process_external_partner_name,
      process_desc: originRows[0].process_desc
    });

    // 거래처 담당자
    var userData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.process_user_seq !== 'undefined' && item.process_user_seq === item2.process_user_seq;
        }) === index
      );
    });

    userData = userData.sort(function(a, b) { 
      return a.process_user_seq < b.process_user_seq ? -1 : a.process_user_seq > b.process_user_seq ? 1 : 0;
    });

    setUserRows(userData.map((item, index) => ({
      id: item.process_user_seq,
      process_user_id: item.process_user_id,
      process_user_name: item.process_user_name,
      process_user_dept_name: item.process_user_dept_name,
      process_user_position_name: item.process_user_position_name,
      process_user_type: item.process_user_type,
      process_user_bigo: item.process_user_bigo,
      row_type: 'O',
      update_type: 'N'
    })));
  }

  const handleSetting = () => {

    setUserColumns([
        {
          field: 'actions',
          headerName: '동작',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              ((params.row.update_type === "U")? 
              <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
              : (params.row.row_type === "A" && params.row.update_type === "N")? 
              <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
              :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
              )
            ],
          headerAlign: 'center', 
          align:'center'
        },
        { field: 'id', headerName: 'process_user_seq', width: 0, headerAlign: 'center' },
        { field: 'process_user_id', headerName: 'process_user_id', width: 0, headerAlign: 'center' },
        { field: 'process_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
        { field: 'process_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
        { field: 'process_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
        { field: 'process_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
          valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
          userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
          editable: true, headerAlign: 'center', align:'center' },
        { field: 'process_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
        { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
        { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      process_user_id: false,
      process_user_name: true,
      process_user_dept_name: true,
      process_user_position_name: true,
      process_user_type: true,
      process_user_bigo: true,
      row_type: false,
      update_type: false
    });
  }

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    process_user_id: false,
    process_user_name: true,
    process_user_dept_name: true,
    process_user_position_name: true,
    process_user_type: true,
    process_user_bigo: true,
    row_type: false,
    update_type: false
  });
  
  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleInitSelect();
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);
  
  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  useEffect(() => {
    if(inputs.process_external_yn === 'Y' && inputs.process_external_partner_name === ''){
      setSelectPartnerModalTitle('외부공정 거래처 목록')
      setSelectPartnerModalOpen(true);
    }else if(inputs.process_external_yn === 'N'){
      const nextInputs = {
        ...inputs,
        ['process_external_partner_id'] : '',
        ['process_external_partner_name'] : ''
      };
      setInputs(nextInputs);
    }
  }, [inputs.process_external_yn]);

  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        process_user_id: '',
        process_user_name: '',
        process_user_dept_name: '',
        process_user_position_name: '',
        process_user_type: 0,
        process_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시
    if(inputs.process_external_yn === 'Y'){
      setSelectPartnerModalTitle('외부공정 거래처 목록')
      setSelectPartnerModalOpen(true);
    }else{
      Swal.fire({
        title: '<p style="color:red">거래처 선택 오류</p>',
        html: '외부공정만 거래처를 선택 할 수 있습니다.',
        confirmButtonText: '확인'
      });
    }
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    if(oldRow.process_user_id !== newRow.process_user_id || oldRow.process_user_type !== newRow.process_user_type || oldRow.process_user_bigo !== newRow.process_user_bigo){
      //담당자 Rows Update
      const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
      const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우    if(newRow != oldRow){
      
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_process_user_id = '';
      var row_process_user_name = '';
      var row_process_user_type = 0;
      var row_process_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.row_resource_user_id !== '' || newRow.row_resource_user_name !== '' || (newRow.resource_user_type !== 0 && newRow.resource_user_type !== null) || newRow.row_process_user_bigo !== '' ){
          row_process_user_id = newRow.process_user_id;
          row_process_user_name = newRow.process_user_name;
          row_process_user_type = newRow.process_user_type;
          row_process_user_bigo = newRow.process_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.process_user_id !== newRow.process_user_id || data.process_user_name !== newRow.process_user_name || data.process_user_type !== newRow.process_user_type || data.process_user_bigo !== newRow.process_user_bigo )?
          (
            row_process_user_id = data.process_user_id,
            row_process_user_name = data.process_user_name,
            row_process_user_type = data.process_user_type,
            row_process_user_bigo = data.process_user_bigo
          ):""
        )
      }
      
      if(row_process_user_id === '' && row_process_user_name === '' && row_process_user_bigo === '' && (row_process_user_type === 0 || row_process_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const userAddClick = (object) => {
    //자원 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        process_user_id: '',
        process_user_name: '',
        process_user_dept_name: '',
        process_user_position_name: '',
        process_user_type: 0,
        process_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        process_user_id: object.row.process_user_id,
        process_user_name: object.row.process_user_name,
        process_user_dept_name: object.row.process_user_dept_name,
        process_user_position_name: object.row.process_user_position_name,
        process_user_type: object.row.process_user_type,
        process_user_bigo: object.row.process_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //공정 담당자 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        process_user_id: object.row.process_user_id,
        process_user_name: object.row.process_user_name,
        process_user_dept_name: object.row.process_user_dept_name,
        process_user_position_name: object.row.process_user_position_name,
        process_user_type: object.row.process_user_type,
        process_user_bigo: object.row.process_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'process_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        process_user_id: params.row.process_user_id,
        process_user_name: params.row.process_user_name,
        process_user_dept_name: params.row.process_user_dept_name,
        process_user_position_name: params.row.process_user_position_name,
        process_user_type: params.row.process_user_type,
        process_user_bigo: params.row.process_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handleUserClick = (object) => {
    //거래처목록 모달에서 클릭한 값으로 품목 거래처 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].process_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.process_user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            process_user_id: object.id,
            process_user_name: object.user_name,
            process_user_dept_name: object.dept_name,
            process_user_position_name: object.position_name,
            process_user_type: selectUserData.process_user_type,
            process_user_bigo: selectUserData.process_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            process_user_id: selectUserData.process_user_id,
            process_user_name: selectUserData.process_user_name,
            process_user_type: selectUserData.process_user_type,
            process_user_dept_name: selectUserData.process_user_dept_name,
            process_user_position_name: selectUserData.process_user_position_name,
            process_user_bigo: selectUserData.process_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handlePartnerClick = (object) => {
    const nextInputs = {
      ...inputs,
      ['process_external_partner_id'] : object.id,
      ['process_external_partner_name'] : object.partner_name
    };
    setInputs(nextInputs);
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.process_name).trim() === ''){
      msg = '공정명 필수 입력 값 입니다.'
    }else if(inputs.process_external_yn === 'Y' && (inputs.process_external_partner_id === 0 || inputs.process_external_partner_id === '' || inputs.process_external_partner_name === '')){
      msg = '외부공정일때 외부공정거래처는 필수 입력 값 입니다.'
    }else if(inputs.process_external_yn === 'N' && (inputs.process_external_partner_id !== 0 && inputs.process_external_partner_id !== '' && inputs.process_external_partner_name !== '')){
      msg = '내부공정일때 외부공정거래처는 입력할 수 없습니다.'
    }
    
    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < userRows.length; i++) {
        const process_user_id = userRows[i].process_user_id;
        const process_user_name = userRows[i].process_user_name;
        const process_user_dept_name = userRows[i].process_user_dept_name;
        const process_user_position_name = userRows[i].process_user_position_name;
        const process_user_type = userRows[i].process_user_type;
        const process_user_bigo = userRows[i].process_user_bigo;
        for(let j = i+1; j < userRows.length; j++) {
          if(process_user_id === userRows[j].process_user_id && process_user_id !== '' && process_user_type === userRows[j].process_user_type && (process_user_type !== 0 || process_user_type !== null || process_user_type !== '')) {
            msg = '중복된 담당자+담당자유형이 존재합니다.<br/>[중복된 담당자 : '+process_user_name+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateUserRows.length; i++) {
        const process_user_id = updateUserRows[i].process_user_id;
        const process_user_name = updateUserRows[i].process_user_name;
        const process_user_type = updateUserRows[i].process_user_type;
        
        if(process_user_id === '' || process_user_name === '') {
          msg = '선택되지 않은 담당자명이 존재합니다.';
          break;
        }
        
        if((process_user_type === 0 || process_user_type === null || process_user_type === '')) {
          msg = '선택되지 않은 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">공정 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Process/Reg", {inputs, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '공정 수정 완료',
            text: '정상적으로 공정이 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleView();
          });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }

  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="공정 정보" value="1" />
                <Tab label="공정 담당자" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">공정명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="공정명" value={inputs.process_name} name="process_name" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">공정유형</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '274px'} }>
                          <Select style={ { width: '80px' } } className="modal_filed_input_select" placeholder="공정유형" value={externalModalOption.filter(function (option) { return option.value === inputs.process_external_yn;  })} onChange={(e) => onSelectChange('process_external_yn',e.value)} options={externalModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                          { inputs.process_external_yn === 'N'?
                          <>
                          </>
                          :
                          <>
                          &nbsp;&nbsp;&nbsp;
                          <input type="text" style={ { width: '120px', cursor: 'pointer', fontWeight:'bold', color: 'black' } }  placeholder="외부공정거래처" value={inputs.process_external_partner_name} name="process_external_partner_name" onClick={(e) => onClick(e) } autoComplete="off" readOnly />
                          </>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">공정설명</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="공정설명" name="process_desc" value={inputs.process_desc} onChange={(e) => onChange(e) } style={{width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processUserRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    {updateFlag &&
                    <div className="modal_button">
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                    </div> }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
        {isSelectPartnerModalOpen && (<PartnerSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectPartnerModalTitle}
          handlePartnerClick={handlePartnerClick}
          />)}
    </PCModal>
  );
}

export default ProcessUpdateModal;